<template>
  <z-container fluid>
    
    <h3 class="text-body-1 mb-3">Pagamento Fornecedor</h3>

    <v-card class="mb-3">
      <v-toolbar flat color="white" dense>
        <h3 class="text-subtitle-2">Cliente</h3>
      </v-toolbar>
      <v-divider></v-divider>

      <v-card-text class="py-2">
        <v-row dense>
          <v-col sm="3">
            <v-text-field filled dense label="Código Fornecedor" v-model="pagamentosStore.fornecedor.id" hide-details readonly></v-text-field>
          </v-col>
          <v-col sm="6">
            <v-text-field filled dense label="Nome" v-model="pagamentosStore.fornecedor.razao" hide-details readonly></v-text-field>
          </v-col>
          <v-col sm="3">
            <v-text-field filled dense label="Celular" v-model="pagamentosStore.fornecedor.celular" hide-details readonly></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mb-3">
      <v-toolbar flat color="white" dense>
        <h3 class="subtitle-2">Contas a Pagar</h3>
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" @click="incluirContasPagar">
          Adicionar Conta a Pagar
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text>

        <v-data-table
          :items="contas_pagar"
          :headers="headers"
          hide-default-footer
          disable-pagination
          item-key="id"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.documento }}</td>
              <td>{{ props.item.forma_pagamento}}</td>
              <td>{{ props.item.vencimento | dataBR}}</td>
              <td class="text-right">{{ props.item.valor | valorBR}}</td>
              <td class="text-right">{{ props.item.valor_restante | valorBR}}</td>
              <td class="text-right">{{ props.item.pagamento | valorBR}}</td>
              <td class="text-right">{{ props.item.saldo | valorBR}}</td>
              <td class="text-right">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon class="ma-0" @click="remover(props.item)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Remover</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:body.append="{items}">
            <tr>
              <td><b>Docs: {{ items.length }}</b></td>
              <td class="text-right" colspan="4"><b>{{ pagamentosStore.somaRestante | valorBR }}</b></td>
              <td class="text-right"><b>{{ pagamentosStore.somaPagamentos | valorBR }}</b></td>
              <td class="text-right"><b>{{ pagamentosStore.somaSaldo | valorBR }}</b></td>
              <td></td>
            </tr>
          </template>
        </v-data-table>

      </v-card-text>
    </v-card>

    <v-card style="margin-bottom: 200px">
      <v-toolbar flat color="white" dense>
        <h3 class="subtitle-2">Pagamentos</h3>
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" @click="novoPagamento" :disabled="pagamentosStore.somaSaldo == 0">
          Adicionar Pagamento
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>

      <v-card-text>

        <v-data-table
          :headers="headersPagamentos"
          :items="pagamentosStore.pagamentos"
          hide-default-footer
          item-key="id"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.data | dataBR}}</td>
              <td>{{ props.item.forma_pagamento}}</td>
              <td class="text-right">{{ props.item.valor | valorBR}}</td>
              <td class="text-right">
                <v-tooltip bottom v-if="props.item.forma_pagamento == 'PIX'">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon class="ma-0" @click="enviarWhatsApp(props.item)">
                      <v-icon>mdi-whatsapp</v-icon>
                    </v-btn>
                  </template>
                  <span>Enviar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon class="ma-0" @click="pagamentosStore.removerPagamento(props.item)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Remover</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:body.append="props">
            <tr>
              <td class="text-right" colspan="3"><b>{{ pagamentosStore.somaPagamentos | valorBR }}</b></td>
              <td></td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$router.back()" :disabled="$store.state.loading">Cancelar</v-btn>
        <v-btn depressed color="primary" @click="finalizar" :loading="$store.state.loading" :disabled="podeFinalizar">Finalizar</v-btn>
      </v-card-actions>
    </v-card>

    <z-dialogo ref="dialogoAdicionarContaAPagar" titulo="Adicionar Conta a Pagar" :dividers="true" largura="1024px" altura="400px" scrollable>
      <div slot="texto">
        <z-loading :loading="loading" height="100px" color="primary"></z-loading>
        <h3 class="subtitle-2 text-center mt-5" v-if="!loading && pagamentosStore.listaContasEmAberto.length == 0">Não há mais contas a pagar desse fornecedor</h3>
        <v-data-table v-if="!loading && pagamentosStore.listaContasEmAberto.length > 0"
          :headers="headersEmAberto"
          :items="pagamentosStore.listaContasEmAberto"
          hide-default-footer
          item-key="id"
          show-select
          v-model="selected"
          disable-pagination
        >
          <template v-slot:item="props">
            <tr :active="props.selected" @click="props.select(!props.isSelected)" style="cursor: pointer">
              <td>
                <v-simple-checkbox :value="props.isSelected" @input="props.select(!props.isSelected)" color="primary"></v-simple-checkbox>
              </td>
              <td>{{ props.item.documento }}</td>
              <td>{{ props.item.forma_pagamento}}</td>
              <td>{{ props.item.vencimento | dataBR}}</td>
              <td class="text-right">{{ props.item.valor | valorBR}}</td>
              <td class="text-right">{{ props.item.valor_restante | valorBR}}</td>
              <!-- <td class="text-right">{{ props.item.saldo | valorBR}}</td> -->
            </tr>
          </template>
        </v-data-table>
      </div>

      <div slot="actions_left">
        <span class="subtitle-2">
          Total selecionado: <b>{{ selected.reduce((soma, sel) => soma + Number(sel.valor_restante), 0) | valorBR}}</b>
        </span>
      </div>

      <v-btn text @click="$refs.dialogoAdicionarContaAPagar.fechar()">Cancelar</v-btn>
      <v-btn color="primary darken-1" depressed @click="confirmarContasAPagar">Confirmar</v-btn>
    </z-dialogo>

    <z-dialogo ref="dialogoAdicionarPagamento" titulo="Adicionar Pagamento" :dividers="true" largura="700px">
        <div slot="texto">
          <!-- <v-container grid-list-md> -->
            <v-form  v-model="valido" ref="form" class="v-form">
                <v-row dense>
                  <v-col sm="4">
                    <z-date-picker-menu v-model="pagamento.data" label="Data" placeholder=" " :rules="regras.data" :readonly="!config.ALTERAR_DATA_AO_LANCAR_RECEBIMENTO" filled dense></z-date-picker-menu>
                  </v-col>
                  <v-col sm="4">
                    <v-select v-model="pagamento.forma_pagamento" label="Forma de Pagamento" :items="$globals.FORMAS_DE_PAGAMENTO_CAIXA.concat(['Desconto'])" filled dense></v-select>
                  </v-col>
                  <v-col sm="4">
                    <z-campo-valor v-model="pagamento.valor" ref="valor" label="Valor" placeholder=" " :rules="regras.valor" @keyup.enter="confirmarPagamento" filled dense></z-campo-valor>
                    <!-- <v-text-field class="ml-2" v-model="pagamento.valor" ref="valor" label="Valor" placeholder=" " :rules="regras.valor"></v-text-field> -->
                  </v-col>
                </v-row>
            </v-form>
          <!-- </v-container> -->
        </div>
        <v-btn text @click="$refs.dialogoAdicionarPagamento.fechar()">Cancelar</v-btn>
        <v-btn color="primary darken-1" depressed @click="confirmarPagamento" :disabled="!valido">Confirmar</v-btn>
    </z-dialogo>

    <z-dialogo ref="dialogoUsarHaver" titulo="Usar haver" :dividers="true" largura="700px">
        <div slot="texto">
          <v-container>
            <p class="body-2">Este cliente possue um haver de R$ {{ this.cliente.haver | valorBR }}.</p>
            <p class="body-2">Deseja usá-lo?</p>
          </v-container>
        </div>
        <v-btn text @click="$refs.dialogoUsarHaver.fechar(); novoPagamento(false)">Não</v-btn>
        <v-btn color="primary darken-1" text @click="confirmarHaver">Sim</v-btn>
    </z-dialogo>

    <z-dialogo-sim-nao ref="dialogoGerarHaver" titulo="Gerar haver" :dividers="true" largura="700px">
      <div class="text--primary">
        <p class="body-2">O valor pago é maior que o valor a receber.</p>
        <p class="body-2">Deseja gerar um haver de R$ {{ this.valorHaver | valorBR }} para o cliente?</p>
      </div>
    </z-dialogo-sim-nao>

    <z-dialogo-sim-nao ref="dialogoFinalizarPagamento" titulo="Finalizar Pagamento?" :dividers="true" largura="500px" botaoSim="Finalizar" botaoNao="Cancelar">
      <p class="body-2">O pagamento será finalizado e as contas serão atualizadas. Deseja finalizar?</p>
    </z-dialogo-sim-nao>

    <CompartilharConta ref="dialogoCompartilharConta"></CompartilharConta>
  </z-container>
</template>

<script>
  import { mapMutations, mapActions, mapState, mapGetters } from "vuex";

  import { usePagamentosStore } from "@/app/store/pinia/pagamentos";

  import CompartilharConta from "./CompartilharConta.vue";


  export default {
    name: 'recebimento-promissorias',

    components: {
      CompartilharConta
    },

    data: () => ({
      pagamento: {
        data: '',
        forma_pagamento: 'Dinheiro',
        valor: 0
      },
      // promissorias: [],
      // pagamentos: [],
      headers: [
        { text: 'Documento', value: 'documento', sortable: false },
        { text: 'Tipo', value: 'forma_pagamento', sortable: false },
        { text: 'Vencimento', value: 'vencimento', width: '100px', sortable: false },
        { text: 'Valor', value: 'valor', align: 'right', width: '150px', sortable: false },
        { text: 'Restante', value: 'valor_restante', align: 'right', width: '130px', sortable: false },
        { text: 'Pagamentos', value: 'pagamento', align: 'right', width: '110px', sortable: false },
        { text: 'Saldo', value: 'saldo', align: 'right', width: '110px', sortable: false },
        { text: 'Opções', value: '', align: 'right', sortable: false }
      ],
      headersEmAberto: [
        { text: 'Documento', value: 'documento', sortable: false},
        { text: 'Tipo', value: 'forma_pagamento', sortable: false },
        { text: 'Vencimento', value: 'vencimento', width: '80px', sortable: false },
        { text: 'Valor', value: 'valor', align: 'right', width: '80px', sortable: false },
        { text: 'Restante', value: 'valor_restante', align: 'right', width: '80px', sortable: false },
      ],
      headersPagamentos: [
        { text: 'Data', value: 'data',  width: '150px', sortable: false},
        { text: 'Tipo', value: 'forma_pagamento', sortable: false },
        { text: 'Valor', value: 'valor', align: 'right', width: '150px', sortable: false },
        { text: 'Opções', value: '', align: 'right', sortable: false }
      ],
      loading: false,
      selected: [],
      valido: false,
      regras: {
        data: [v => !!v || 'Informe uma data'],
        valor: [v => (v != '0,00') || 'Digite o valor do pagamento']
      },
      pagamentosStore: usePagamentosStore(),
    }),

    beforeRouteLeave(to, from, next) {
      this.pagamentosStore.limparPagamentosContasAPagar();

      next();
    },

    mounted() {
      this.setTitulo('Pagamento Fornecedor');
      if (!this.fornecedor.id) {
        this.$router.push({ name: 'ExtratoFornecedor' });
      }

      // this.$vuetify.goTo(0);
      // this.$store.commit('financeiro/SET_DRAWER_CLIENTES', true);
    },

    computed: {
      fornecedor() {
        return this.pagamentosStore.fornecedor;
      },
      ...mapState('clientes', { cliente: 'cliente' }),
      ...mapState('recebimentos', ['promissoriasEmAberto', 'promissorias', 'pagamentos']),
      ...mapGetters('recebimentos', ['listaPromissoriasEmAberto', 'somaPagamentos', 'somaPromissorias', 'somaRestante', 'somaPagamentosPromissorias', 'somaSaldo']),
      
      podeFinalizar() {
        return this.pagamentosStore.somaPagamentos > 0 && this.pagamentosStore.somaContasAPagar > 0 ? false : true;
      },

      valorHaver() {
        return this.pagamentosStore.somaPagamentos - this.pagamentosStore.somaRestante;
      },

      config() {
        return this.$store.state.configuracoes;
      },

      pagamentos() {
        return this.pagamentosStore.pagamentos;
      },
      contas_pagar() {
        return this.pagamentosStore.contas_pagar;
      },
    },


    methods: {
      ...mapMutations(['setTitulo']),
      ...mapMutations('recebimentos', ['adicionarPromissoria', 'adicionarRecebimento', 'removerRecebimento', 'removerPromissoria', 'atualizarPagamentosPromissorias', 'limparPagamentosPromissorias', 'SET_PROMISSORIA']),
      ...mapActions('recebimentos', ['listarPromissoriasEmAberto', 'finalizarRecebimento']),
      ...mapActions('financeiro', ['extratocliente']),
      ...mapActions({
        abrirCliente: 'clientes/abrir'
      }),

      async incluirContasPagar() {
        this.loading = true;
        this.selected = [];
        this.$refs.dialogoAdicionarContaAPagar.abrir();
        await this.pagamentosStore.listarContasPagarEmAberto();
        this.loading = false;
      },

      confirmarContasAPagar() {
        this.selected.forEach(conta => {
          this.pagamentosStore.adicionarContaPagar(this.clone(conta));
        });

        this.$refs.dialogoAdicionarContaAPagar.fechar();
      },

      novoPagamento() {
        this.$refs.dialogoAdicionarPagamento.abrir();
        this.setFocus('valor');
        this.formReset();
      },

      confirmarPagamento() {
        if (this.$refs.form.validate()) {
          this.pagamentosStore.adicionarPagamento(this.pagamento);
          this.$refs.dialogoAdicionarPagamento.fechar();
          // this.$vuetify.goTo(7000);
        }
      },

      async finalizar(){
        const response = await this.$refs.dialogoFinalizarPagamento.abrir();

        if (response == true) {
          this.$refs.dialogoFinalizarPagamento.startLoading();
          await this.confirmarFinalizar();
          this.$refs.dialogoFinalizarPagamento.fechar();
        }

      },

      async confirmarFinalizar() {
        try {
          this.loading = true;
          await this.pagamentosStore.finalizarPagamento(this.cliente.id);
          this.$eventbus.notificar('Pagamento finalizado.');

          await Promise.all([
            this.pagamentosStore.listarContasPagar(),
            this.pagamentosStore.carregarPagamentosEfetuados()
          ]);

          this.$router.push({ name: 'ExtratoFornecedor' });
        } catch (erro) {
          this.$eventbus.erro('Não foi possível finalizar o pagamento.', erro);
          throw erro;
        } finally {
          this.loading = false;
        }
      },

      confirmarHaver() {
        let valor = this.cliente.haver < this.somaSaldo ? this.cliente.haver : this.somaSaldo
        this.pagamento = {
          data: this.$moment().format('YYYY-MM-DD'),
          forma_pagamento: 'Haver',
          valor: valor
        }

        this.cliente.haver = this.cliente.haver - valor;

        this.adicionarRecebimento(this.pagamento);
        this.$refs.dialogoUsarHaver.fechar();
        this.$vuetify.goTo(7000);
      },

      remover(conta) {
        this.pagamentosStore.removerContaPagar(conta);
      },

      formReset() {
        this.pagamento = {
          data: this.$moment().format('YYYY-MM-DD'),
          forma_pagamento: 'Dinheiro',
          valor: this.pagamentosStore.somaSaldo
        }
      },

      enviarWhatsApp(item) {
        this.$refs.dialogoCompartilharConta.abrir(item);
      },
    },


    watch: {
      pagamentos() {
        this.pagamentosStore.atualizarPagamentosContasAPagar();
      },

      contas_pagar() {
        this.pagamentosStore.atualizarPagamentosContasAPagar();
      }
    }
  }
</script>

<style scoped>

</style>